export default "__VITE_PUBLIC_ASSET__cdd34a44__"